import React from 'react';
import { MapPin, Car, Navigation } from 'lucide-react';
import { travelFees } from '../mockData';
import { Card, CardContent } from './ui/card';
import InteractiveMapDriving from './InteractiveMapDriving';

const ZoneIntervention = () => {
  return (
    <section id="zone-intervention" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Navigation className="text-[#C5A572]" size={40} />
            <h2 className="text-4xl md:text-5xl font-bold text-[#8B9E8A]">
              Zone d'Intervention
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Je me déplace dans toute la Nouvelle-Aquitaine pour offrir mes services à vos animaux
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Carte des zones */}
          <div className="mb-12">
            <InteractiveMapDriving />
          </div>

          {/* Informations sur les frais de déplacement */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Tableau des frais */}
            <Card className="border-[#C5A572]/30 shadow-lg">
              <CardContent className="p-6">
                <h3 className="text-2xl font-bold text-[#8B9E8A] mb-4 flex items-center gap-2">
                  <Car className="text-[#C5A572]" />
                  Frais de Déplacement
                </h3>
                <p className="text-gray-600 mb-4 text-sm">
                  Distance routière depuis Saint-Médard-en-Jalles
                </p>
                <div className="space-y-3">
                  {travelFees.map((fee, index) => (
                    <div 
                      key={index} 
                      className="flex justify-between items-center py-3 border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors px-4 rounded"
                    >
                      <span className="text-gray-700 font-medium">{fee.distance}</span>
                      <span className="text-[#C5A572] font-bold text-lg">{fee.fee}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Informations complémentaires */}
            <div className="space-y-6">
              <Card className="border-[#C5A572]/30 shadow-lg">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-[#8B9E8A] mb-4 flex items-center gap-2">
                    <MapPin className="text-[#C5A572]" />
                    Point de départ
                  </h3>
                  <div className="text-gray-700">
                    <p className="font-semibold text-lg mb-2">Saint-Médard-en-Jalles</p>
                    <p className="text-sm text-gray-500">Nouvelle-Aquitaine, France</p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-[#C5A572]/30 shadow-lg bg-gradient-to-br from-[#8B9E8A]/5 to-white">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-[#8B9E8A] mb-4">
                    💡 Bon à savoir
                  </h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start gap-2">
                      <span className="text-[#C5A572] mt-1">✓</span>
                      <span>Les distances sont calculées par la route (pas à vol d'oiseau)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-[#C5A572] mt-1">✓</span>
                      <span>Je me déplace directement chez vous ou sur le lieu de compétition</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-[#C5A572] mt-1">✓</span>
                      <span>Au-delà de 100 km, contactez-moi pour un devis personnalisé</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-[#C5A572] mt-1">✓</span>
                      <span>Possibilité de regroupement pour réduire les frais</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* Villes principales couvertes */}
          <div className="mt-12 text-center">
            <h3 className="text-xl font-bold text-[#8B9E8A] mb-6">
              Principales villes couvertes
            </h3>
            <div className="flex flex-wrap justify-center gap-3">
              {[
                'Bordeaux', 'Mérignac', 'Pessac', 'Talence', 'Libourne', 
                'Arcachon', 'Andernos', 'Langon', 'La Teste-de-Buch', 
                'Saint-André-de-Cubzac', 'Blaye', 'Pauillac', 'Lesparre-Médoc'
              ].map((city, index) => (
                <span 
                  key={index}
                  className="bg-[#8B9E8A]/10 text-[#8B9E8A] px-4 py-2 rounded-full text-sm font-medium hover:bg-[#8B9E8A]/20 transition-colors"
                >
                  {city}
                </span>
              ))}
            </div>
            <p className="text-gray-500 text-sm mt-4">
              Et bien d'autres communes de Gironde et Nouvelle-Aquitaine...
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZoneIntervention;
